import service from '@/services/superaccess'

const access_profile = {
  state: {
    access_profile_modal: false,
    access_profile: {},
    refresh_form: false
  },
  mutations: {
    updateStatusAccessProfileModal (state, status) {
      state.access_profile_modal = status
    },
    setAccessProfile (state, access_profile) {
      state.access_profile = access_profile
    },
    updateStatusRefreshForm (state, status) {
      state.refresh_form = status
    }
  },
  getters: {
    getStatusAccessProfileModal (context) {
      return context.access_profile_modal
    },
    getAccesProfile (context) {
      return context.access_profile
    },
    getRefreshForm (context) {
      return context.refresh_form
    }
  },
  actions: {
    retrieveDetailsAP (context, payload) {
      return service.post('/api/access_profiles/new', context)
    },
    retrieveDetailsAPByDepartment (context, payload) {
      return service.post('/api/access_profiles/new', context, { department: payload })
    },
    saveAccessProfile (context, payload) {
      return service.post('/api/access_profiles/create', context, payload)
    },
    modifyAccessProfile (context, payload) {
      return service.patch('/api/access_profiles/modify', context, payload)
    },
    changeAccessProfileStatus (context, payload) {
      return service.patch('/api/access_profiles/change', context, payload)
    },
    setStatusAccessProfileModal (context, payload) {
      context.commit('updateStatusAccessProfileModal', payload)
    },
    setDataAccessProfile (context, payload) {
      context.commit('setAccessProfile', payload)
    },
    setStatusRefreshForm (context, payload) {
      context.commit('updateStatusRefreshForm', payload)
    }
  }
}

export default access_profile



// WEBPACK FOOTER //
// app/javascript/src/store/access_profile.js